import React from 'react';
import Actions from '../../../components/Actions';
import Search from '../../../components/Search';
import Button from '../../../components/Button';
import Icon from '../../../components/Icon';
import Checkbox from '../../../components/Checkbox';
import { BulkUpdateServiceRequest } from './BulkUpdateServiceRequest';
import { isRole } from 'src/helpers/permissions';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import './ServiceRequestDashboardActions.scss';

interface IServiceRequestDashboardActionsProps {
  searchString: string;
  onChangeSearchString: (value: string) => void;
  onShowFilterOverlay: () => void;
  filterCount: number;
  disableGroup: boolean;
  onGroup: () => void;
  onBulkStatusUpdate: (status: string) => void;
  showResolved: boolean;
  onShowResolved: () => void;
  onDownload: () => void;
}

export const ServiceRequestDashboardActions = ({
  searchString,
  onChangeSearchString,
  onShowFilterOverlay,
  filterCount,
  disableGroup,
  onGroup,
  onBulkStatusUpdate,
  showResolved,
  onShowResolved,
  onDownload,
}: IServiceRequestDashboardActionsProps) => {
  const user = useSelector(selectAuthenticatedUser);

  return (
    <Actions sticky compact>
      <div className="serviceRequestDashboardActions groupContainer">
        <Search
          value={searchString}
          onChange={(c) => onChangeSearchString(c.target.value)}
          placeholder="Search Service Requests"
          size="small"
          theme={null}
        />
        <Button
          color="teal"
          label={`Filter By ${filterCount > 0 ? `(${filterCount})` : ''}`}
          size="small"
          onClick={onShowFilterOverlay}
          icon={<Icon glyph="filter" weight="light" size="small" />}
          block={undefined}
          disabled={undefined}
          outlined={undefined}
          outline={undefined}
          weight={undefined}
          children={undefined}
          style={undefined}
        />
      </div>
      <div className="serviceRequestDashboardActions groupContainer groupContainer__right">
        <Checkbox
          label="Show Resolved Tickets"
          size="small"
          value={showResolved}
          onChange={() => onShowResolved()}
          containerStyle={{ marginBottom: 0, marginRight: '1rem' }}
        />
        {!isRole(['Home Owner', 'Realtor', 'Vendor'], user) && (
          <div style={{ display: 'flex', gap: '1rem' }}>
            <Button
              color="teal"
              disabled={disableGroup}
              onClick={onGroup}
              label="Group"
              size="small"
              block={undefined}
              outlined={undefined}
              icon={undefined}
              outline={undefined}
              weight={undefined}
              children={undefined}
              style={undefined}
            />
            <BulkUpdateServiceRequest
              disableBulkUpdate={disableGroup}
              onChangeStatus={onBulkStatusUpdate}
              style={{ marginRight: 0 }}
            />
          </div>
        )}
        <div onClick={onDownload}>
          <Icon glyph="download" weight="regular" size="big" />
        </div>
      </div>
    </Actions>
  );
};
